import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=9cc0040e&scoped=true&"
import script from "./card-list.vue?vue&type=script&lang=js&"
export * from "./card-list.vue?vue&type=script&lang=js&"
import style0 from "./card-list.vue?vue&type=style&index=0&id=9cc0040e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc0040e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Scroll})
